import api from 'api/axios';

export async function getSignupKeys() {
  try {
    return await api.get("/admin/signup-keys");
  } catch (err) {
    return err.response;
  }
}

export async function generateSignupKey(payload) {
  try {
    return await api.post("/admin/signup-keys", payload);
  } catch (err) {
    return err.response;
  }
}

export async function updateSignupKeyLimit(id, maxUsage) {
  try {
    return await api.patch(`/admin/signup-keys/${id}`, { maxUsage });
  } catch (err) {
    return err.response;
  }
}

export async function deleteSignupKey(id) {
  try {
    return await api.delete(`/admin/signup-keys/${id}`);
  } catch (err) {
    return err.response;
  }
}

export async function getJoinedDoctors(id) {
  try {
    return await api.get(`/admin/signup-keys/${id}/doctors`);
  } catch (err) {
    return err.response;
  }
}
